import { useTranslation } from "react-i18next";


interface MysteryBoxRewardModalProps {
  isOpen: boolean;
  onClose: () => void;
  rewardType: "exp" | "pearls";
  rewardAmount: number;
  isLoading?: boolean; // Чи завантажується нагорода з бекенду
}

export default function MysteryBoxRewardModal({ isOpen, onClose, rewardType, rewardAmount, isLoading = false }: MysteryBoxRewardModalProps) {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[2000] flex items-center justify-center bg-black-alpha-59 px-xl py-2xl"
      onClick={isLoading ? undefined : onClose}
    >
      <div
        className="relative z-[2001] box-border flex w-full max-w-[372px] flex-col items-center rounded-xl border-[3px] border-deep-blue bg-fullscreen-surface px-2xl py-4xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex w-full flex-col items-center gap-3xl text-center">
          <div className="w-full [font-family:Lato,sans-serif] text-[clamp(16px,4vw,18px)] leading-normal font-normal text-white">
            {t("At last, the Mystery box yields to you and opens. Inside you find:")}
          </div>

          {isLoading ? (
            <div className="flex items-center justify-center gap-lg py-2xl">
              <div className="h-6 w-6 animate-[spin_0.8s_linear_infinite] rounded-full border-2 border-white-alpha-30 border-t-white-alpha-80" />
              <span className="[font-family:Lato,sans-serif] text-[clamp(14px,3.5vw,16px)] font-normal text-white-alpha-80">
                {t("Loading...")}
              </span>
            </div>
          ) : (
            <div className="flex items-center justify-center gap-md">
              {rewardType === "pearls" ? (
                <>
                  <span className="[font-family:'Rubik_One',sans-serif] text-[clamp(20px,5vw,24px)] font-normal text-white">
                    +{rewardAmount.toLocaleString("en-US")}
                  </span>
                  <img
                    src="/ui/world-map/shell-icon.png"
                    alt={t("Pearls")}
                    className="h-8 w-8"
                  />
                </>
              ) : (
                <span className="[font-family:'Rubik_One',sans-serif] text-[clamp(20px,5vw,24px)] font-normal text-white">
                  +{rewardAmount.toLocaleString("en-US")} EXP
                </span>
              )}
            </div>
          )}

          {!isLoading && (
            <button
              onClick={onClose}
              className="mt-md cursor-pointer whitespace-nowrap rounded-[34.925px] border-none bg-white px-4xl py-[10px] [font-family:'Rubik_One',sans-serif] text-[16px] leading-[20px] font-normal text-text-dark"
            >
              OK
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
